import { BaseProps } from '@/components/types'
import { CSSProperties, useState } from 'react'
import { SeeMore } from '@/components'

function ItemList<TValue = any>( props: ItemListProps<TValue> ) {
    const {
        className, noFlex = false,
        datas = [], style, defaultShowItemCount = 10,
        renderContents
    } = props
    const [ showItemCount, setShowItemCount ] = useState( defaultShowItemCount )

    const flexStyle: CSSProperties = {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-between',
        ...style
    }

    return (
        <>
            <div
                className={ className }
                style={
                    noFlex
                        ? { ...style }
                        : { ...flexStyle, ...style }
                }
            >
                {
                    datas.length !== 0 && renderContents && datas.map( ( data, idx ) => {
                        return renderContents( data, idx )
                    } ).slice( 0, showItemCount > datas.length ? datas.length : showItemCount )
                }
            </div>
            {
                datas.length !== 0 &&
                    <SeeMore
                        defaultShowCount={ defaultShowItemCount }
                        setShowCount={ setShowItemCount }
                        totalList={ datas }
                        marginTop="8px"
                        marginBottom="8px"
                    />
            }
        </>
    )
}

export default ItemList

export interface ItemListProps<TValue = any> extends BaseProps {
    datas: TValue[]
    defaultShowItemCount?: number
    noFlex?: boolean
    renderContents?: ( data: TValue, idx: number ) => JSX.Element
}